const f = {
  black: "#000",
  white: "#fff"
};
export {
  f as default
};
